/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  {
    url: '/request',
    icon: "PlusIcon",
    slug: 'addRequest',
    i18n: 'SubmitRequest',
    permission: 301,
  },
  {
    url: null,
    icon: "ListIcon",
    i18n: "Tasks",
    tag: '',
    tagColor: '#8888ff',
    submenu: [
      {
        url: '/task/inConfirmation',
        icon: "MailIcon",
        slug: 'tasksInConfirmation',
        i18n: 'TasksInConfirmation',
        tag: '',
        tagColor: '#8888ff',
      },
      {
        url: '/task/all',
        icon: "ListIcon",
        slug: 'allTasks',
        i18n: 'TasksAll',
      },
      {
        url: '/task/finished',
        icon: "CheckCircleIcon",
        slug: 'finishedTasks',
        i18n: 'TasksFinished',
      },
    ],
  },
  {
    url: '/projects',
    icon: "AwardIcon",
    slug: 'projects',
    i18n: 'Projects',
    permission: 201,
  },
  {
    url: "/invoices",
    name: "Invoices",
    slug: "invoices",
    icon: "DollarSignIcon",
    i18n: 'Invoices',
    permission: 101,
  },
]
